import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { marginAttributes } from '../../system/attributes';
import { getPropsBlocker } from '../../utils';
import { Typography } from '../Typography';

var themeStyle = function themeStyle(_ref) {
  var TabView = _ref.theme.componentOverrides.TabView;
  return TabView.Root.base;
};

export var TabViewRoot = styled(Typography).withConfig(getPropsBlocker({}, false))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    ", "\n"])), themeStyle, marginAttributes);